export default __webpack_public_path__ + "static/media/background.3a286a2c.svg";